type AntDesignConfigData = {
    scrollBehavior: {
        behavior: ScrollBehavior | undefined;
    };
};

const antDesignConfig: AntDesignConfigData = {
    scrollBehavior: { behavior: "smooth" }
};

export default antDesignConfig;